module.exports = __webpack_public_path__ + "static/img/weather50.669a827d.png";